// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"591":"4bbf7bef","747":"27a9ab52","787":"ca380a52","894":"e3b66634"}[chunkId] + ".chunk.js";
};